/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type UpdateSettingsMutationVariables = Types.Exact<{
	input: Types.UpdateSettingActionInput;
}>;

export type UpdateSettingsMutation = {
	__typename?: "Mutation";
	settingsUpdate: { __typename?: "SettingsUpdateResponse"; autoStake: boolean };
};

export const UpdateSettingsDocument = gql`
	mutation UpdateSettings($input: UpdateSettingActionInput!) {
		settingsUpdate(input: $input) {
			... on SettingsUpdateResponse {
				autoStake
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class UpdateSettingsGQLService extends Apollo.Mutation<UpdateSettingsMutation, UpdateSettingsMutationVariables> {
	document = UpdateSettingsDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
